module.exports = __webpack_public_path__ + "img/icon_utility.4546da17.png";